module.exports = __webpack_public_path__ + "img/bg1.b8c0acc6.png";